module.exports = __webpack_public_path__ + "img/monitor-light.4c58b96b.svg";